/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Tijd_OngeldigInputs */

const nl_planning_rooster_tijd_ongeldig = /** @type {(inputs: Planning_Rooster_Tijd_OngeldigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze tijd kan niet: dan wordt een lesuur of pauze te kort.`)
};

/**

* @param {Planning_Rooster_Tijd_OngeldigInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_tijd_ongeldig = /** @type {((inputs?: Planning_Rooster_Tijd_OngeldigInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Tijd_OngeldigInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_tijd_ongeldig(inputs)
});
export { planning_rooster_tijd_ongeldig as "planning.rooster.tijd_ongeldig" }